export const PORTAL_BASE = process.env.REACT_APP_PORTAL_PATH ?? "/portal/contact";
export const PORTAL_PUBLIC_BASE = process.env.REACT_APP_PORTAL_PUBLIC_PATH ?? "/public/portal/contact";

export const PORTAL_ROUTE_DASHBOARD = `${PORTAL_BASE}/dashboard`;
export const PORTAL_ROUTE_DEVICES = `${PORTAL_BASE}/devices`;
export const PORTAL_ROUTE_FAMILY_SHARING = `${PORTAL_BASE}/family-sharing`;
export const PORTAL_ROUTE_SESSION_EXPIRED = `${PORTAL_BASE}/session-expired`;
export const portalRouteMimshak = (policyNumber: string, reportedPeriod?: string) => {
  const base = `${PORTAL_BASE}/mimshak/${encodeURIComponent(policyNumber)}`;
  return reportedPeriod ? `${base}?period=${encodeURIComponent(reportedPeriod)}` : base;
};

export const portalRouteInvestment = (policyNumber: string, reportedPeriod?: string) => {
  const base = `${PORTAL_BASE}/investment/${encodeURIComponent(policyNumber)}`;
  return reportedPeriod ? `${base}?period=${encodeURIComponent(reportedPeriod)}` : base;
};

export const PORTAL_ROUTE_CAPITAL_PORTFOLIO = `${PORTAL_BASE}/capital-portfolio`;
export const PORTAL_ROUTE_PENSION_PORTFOLIO = `${PORTAL_BASE}/pension-portfolio`;
export const PORTAL_ROUTE_PORTFOLIO_TIMELINE = `${PORTAL_BASE}/portfolio-timeline`;
export const PORTAL_ROUTE_DEPOSITS = `${PORTAL_BASE}/deposits`;
